"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = require("./Modal.styles");
var _Modal2 = require("./Modal.labels");
var _Modal3 = require("./Modal.helpers");
var _ModalHeader = require("./partials/ModalHeader");
var _ModalContent = require("./partials/ModalContent");
var _ModalFooter = require("./partials/ModalFooter");
var _ModalFooterSection = require("./partials/ModalFooterSection");
var _Portal = require("../Portal");
var _Button = require("../../UI/Button");
var _hooks = require("../../hooks");
var _Icon = require("../../UI/Icon");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _dom = require("../../utilities/dom");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Modal = function Modal(props) {
  var id = props.id,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'popup' : _props$layout,
    _props$isStandAlone = props.isStandAlone,
    isStandAlone = _props$isStandAlone === void 0 ? false : _props$isStandAlone,
    _props$isWithCloseBut = props.isWithCloseButton,
    isWithCloseButton = _props$isWithCloseBut === void 0 ? true : _props$isWithCloseBut,
    children = props.children,
    _props$isOpen = props.isOpen,
    isOpen = _props$isOpen === void 0 ? false : _props$isOpen;
  var styles = (0, _Modal.useStyles)(props);
  var modalRef = (0, _react.useRef)(null);
  var modalCloseButtonRef = (0, _react.useRef)(null);
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Modal2.labels
  });
  var _getModalFunctions = (0, _Modal3.getModalFunctions)(props),
    handleCloseFromOutside = _getModalFunctions.handleCloseFromOutside,
    handleClose = _getModalFunctions.handleClose;
  var WrapperTag = isStandAlone ? _Portal.Portal : _react.default.Fragment;
  var WrapperModalTag = layout === 'popup' ? 'dialog' : 'section';
  var handleModalKeyDown = function handleModalKeyDown(event) {
    if (event.key === 'Escape') {
      var _modalCloseButtonRef$;
      (_modalCloseButtonRef$ = modalCloseButtonRef.current) === null || _modalCloseButtonRef$ === void 0 ? void 0 : _modalCloseButtonRef$.click();
    } else if (modalRef.current && event.key === 'Tab') {
      var focusableElements = (0, _dom.getKeyboardFocusableElements)(modalRef.current);
      if (focusableElements.length > 0) {
        var firstFocusableElement = focusableElements[0];
        var lastFocusableElement = focusableElements[focusableElements.length - 1];
        if (document.activeElement === firstFocusableElement && event.shiftKey) {
          event.preventDefault();
          lastFocusableElement.focus();
        } else if (document.activeElement === lastFocusableElement && !event.shiftKey) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  };
  (0, _react.useEffect)(function () {
    if (isOpen && modalRef.current) {
      var focusableElements = (0, _dom.getKeyboardFocusableElements)(modalRef.current);
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }
  }, [isOpen]);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(WrapperTag, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ref: modalRef,
      onKeyDown: handleModalKeyDown,
      className: styles['cc-Modal-container'],
      "data-testid": id ? "modal-container-".concat(id) : null,
      children: [!isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Modal-blocker'],
        onClick: handleCloseFromOutside,
        "data-testid": id ? "modal-blocker-".concat(id) : null
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(WrapperModalTag, {
        className: styles['cc-Modal'],
        "data-testid": id ? "modal-".concat(id) : null,
        children: [isWithCloseButton && layout !== 'inline' && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-Modal__close-btn'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "ccModalCloseButton",
            ref: modalCloseButtonRef,
            shape: "round",
            onClick: handleClose,
            color: isMobileView ? 'basic' : 'primary',
            view: isMobileView ? 'outlined' : 'alternate',
            size: isMobileView ? 'small' : 'medium',
            customStyle: isMobileView ? {
              background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
              boxShadow: "0 ".concat(pxToRem(3), " ").concat(pxToRem(5), " ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.shadow)
            } : {
              background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main,
              color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text
            },
            ariaLabel: getLabel('close'),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              name: "Close",
              width: 14,
              height: 14
            })
          })
        }), children]
      })]
    })
  });
};
exports.Modal = Modal;
Modal.Header = _ModalHeader.ModalHeader;
Modal.Content = _ModalContent.ModalContent;
Modal.Footer = _ModalFooter.ModalFooter;
Modal.Footer.Section = _ModalFooterSection.ModalFooterSection;